// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { MultipleSelectionModel } from '../../utils/multiple-selection-model'

export interface IFinderSelectionProps {
  selectionModel: MultipleSelectionModel
}

export class FinderSelection extends React.Component<IFinderSelectionProps> {
  private root = React.createRef<HTMLDivElement>()

  handleClick = (e: React.MouseEvent<HTMLElement>) => {
    const { selectionModel } = this.props
    const isMetaPressed = e.metaKey
    const isShiftPressed = e.shiftKey
    const target = e.target as HTMLElement
    const itemRoot = this.findItemRoot(target)
    if (itemRoot === this.root.current) {
      return
    }
    const selectionIndex = this.getSelectionIndex(itemRoot)
    const wasSelected = selectionModel.isSelected(selectionIndex)
    if (wasSelected) {
      selectionModel.clear(selectionIndex)
    } else {
      if (isMetaPressed) {
        selectionModel.select(selectionIndex)
      } else if (isShiftPressed) {
        const startIndex = Math.max(0, Math.min(selectionModel.getFocusIndex(), selectionIndex))
        const endIndex = Math.max(selectionModel.getFocusIndex(), selectionIndex)
        selectionModel.selectRange(startIndex, endIndex + 1)
      } else {
        selectionModel.clearAndSelect(selectionIndex)
      }
    }
  }

  private findItemRoot = (target: HTMLElement) => {
    const { selectionModel } = this.props
    while (target !== this.root.current) {
      const index = this.getSelectionIndex(target)
      if (index >= 0 && index < selectionModel.getItemCount()) {
        break
      }
      target = target.parentElement
    }
    return target
  }

  private getSelectionIndex (target: HTMLElement) {
    const indexAttr = target.getAttribute('data-selection-index')
    return indexAttr === '' || indexAttr === null ? -1 : Number(indexAttr)
  }

  render () {
    return (
      <div ref={this.root} onClick={this.handleClick} className='finder-selection'>
        {this.props.children}
      </div>
    )
  }
}
